import {useNavigationStore} from '../../hooks/useNavigationStore';

type Props = {
  onClick?: () => void;
};

export default function NavigationButton({onClick}: Props) {
  const {isOpen, toggleOpen} = useNavigationStore();
  return (
    <button
      aria-expanded={isOpen}
      aria-controls="cart"
      onClick={() => {
        toggleOpen();
        onClick?.();
      }}
      className="flex items-center gap-2"
    >
      <p className="transition-opacity duration-500 ease-out hover:opacity-40">
        Shop
      </p>
    </button>
  );
}
